import Vue from 'vue';
import App from './App.vue';
import './assets/icon/iconfont.css';
import router from './router';
import VueI18n from 'vue-i18n';
import store from './store';
import Toast from './components/message/Toast';
import './permission';
// import VConsole from 'vconsole/dist/vconsole.min.js';
//解决安卓滴版本问题
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
if (
	window.location.href.indexOf('duobaogame') > -1 ||
	window.location.href.indexOf('localhost') > -1 ||
	window.location.href.indexOf(':3000') > -1
) {
	// let vConsole = new VConsole();
}
Vue.prototype.$toast = Toast;
Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'zh', // 语言标识
	messages: {
		zh: require('./assets/lang/zh'),
		en: require('./assets/lang/en'),
	},
});
Vue.config.productionTip = false;
new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
